<template>
    <main-layout :showHeader="false">
        <template slot="body">
            <div class="login">
                <div class="login__block active" id="l-login">
                    <div class="login__block__header">
                        <i class="zmdi zmdi-account-circle"></i>
                        {{ $t('LBL_LOGIN_TITLE') }}
                        <div class="mt-3" v-html="loginMessage"></div>
                    </div>

                    <form class="login__block__body needs-validation p-1" @submit.prevent="onSubmit">
                        <base-field v-model="email" name="email" type="email" :label="$t('LBL_USERNAME')" :isCentered="true"
                                    :mandatory="true" :isFloat="true"></base-field>
                        <base-field v-model="password" type="password" name="password" :label="$t('LBL_PASSWORD')"
                                    :mandatory="true" :isCentered="true" :isFloat="true"></base-field>

                        <div v-if="error" class="alert alert-danger" role="alert">
                            {{ error }}
                        </div>


                        <button type="submit" class="btn btn--icon login__block__btn"><i class="zmdi" :class="{ 'zmdi-long-arrow-right': !showLoader, 'zmdi-refresh zmdi-hc-fw rotating': showLoader}"></i></button>
                        <div class="mt-5">
                            <router-link :to="{name: 'RequestAccess'}" class="float-left">{{ $t('LBL_REQUEST_ACCESS_TITLE') }}</router-link>
                            <router-link :to="{name: 'PasswordRecovery'}" class="float-right">{{ $t('LBL_RESET_PASSWORD_TITLE') }}</router-link>
                        </div>
                    </form>
                </div>
            </div>
        </template>
    </main-layout>
</template>

<script>
    import MainLayout from '@/layout/Main'
    import BaseField from '@/components/form_elements/Base'
    import AppHelper from "../helper";

    export default {
        data() {
            return {
                email: '',
                password: '',
                error: '',
                showLoader: false,
                loginMessage: ''
            }
        },

        components: {
            'base-field': BaseField,
            'main-layout': MainLayout,
        },

        $_veeValidate: { validator: "new" },

        methods: {
            async onSubmit() {
                await this.$validator.validateAll()

                if (!this.errors.any() && !this.showLoader) {

                    this.showLoader = true
                    var response = await Api.login(this.email, this.password)
                    this.showLoader = false

                    if(!response.success){
                        this.error = response.error.label
                    }
                    else{
                        // Get path to redirect after login
                        var path = this.$store.state.redirect.path

                        if(!AppHelper.empty(path)){
                            // Resets redirect path
                            this.$store.commit('setRedirect', {})
                            this.$router.replace({path: path})
                        }
                        else{
                            this.$router.push({path: '/home/ '})
                        }
                    }
                }
            }
        },

        async mounted() {
            var response = await Api.getLoginMessage()
            if(response.success){
                this.loginMessage = response.result
            }
        },

        beforeRouteEnter (to, from, next) {
            if(Api.isAuthenticated()){
                next({path: '/home/ '})
            }
            else{
                next()
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/Login.vue